import type { MyPageConfig } from '../../@types/context/my-page-config.types';

/**
 * MVX-678 (CCD2 R04): every Finnish brand shows the automated-decision notice,
 * with its auto-accept paragraph (the copy is the notice's `fi-FI` labels).
 * Unlike Sweden, the footer doesn't change.
 *
 * MVX-602 (CCD2 R10): no "recommended" badge; the engine's rank-1 offer is
 * labelled by its criterion instead.
 */
export const myPageCcd2FiOptions: Pick<
  MyPageConfig['options'],
  'hasAutomatedDecisionNotice' | 'hasCriterionLabel'
> = {
  hasAutomatedDecisionNotice: true,
  hasCriterionLabel: true,
};
